















































































































































































































import Context from "@/mixins/context";
import { IAccount } from "@/models/accounts";
import BrandsStore from "@/mixins/brandsStore";
import AdminBrands from "@/mixins/adminBrands";
import { DataModules } from "@/store/modules/data";
import { IAffiliateLink } from "@/models/affiliate";
import {
  IAffiliateProvider,
  IAffiliateProviderMethods
} from "@/models/providers/affiliate";
import { Component, Prop, Mixins, Inject } from "vue-property-decorator";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { ConfirmModalModes } from "@/data/enums";
import { affiliateLinksFilters } from "@/data/filters/affiliate";
import { affiliateLinksSorters } from "@/data/sorters/affiliate";

@Component
export default class AffiliateLinksTable extends Mixins(
  BrandsStore,
  AdminBrands,
  FilteringSortingTableStore,
  Context
) {
  @Inject({ from: "affiliateProviderMethods" })
  public readonly $affiliateMethods!: IAffiliateProviderMethods;

  @Inject({ from: "affiliateProvider" })
  public readonly $affiliateData!: () => IAffiliateProvider;

  // Props
  @Prop({ required: true })
  public accountId!: IAccount["id"];

  // Data
  public dataModule: string = DataModules.AFFILIATES_LINKS;

  public filters = this.$_.cloneDeep(affiliateLinksFilters);
  public sorters = this.$_.cloneDeep(affiliateLinksSorters);

  public async created() {
    if (!this.contentAvailable) return;
    this.getData();

    this.$bus.$on("refreshAffiliateLinksTable", () => {
      this.getData({ ignoreStored: true });
    });
  }

  // Getters
  public get contentAvailable() {
    return this.$userCan("list_affiliate_account_links");
  }

  public get affiliateData() {
    return this.$affiliateData();
  }

  public async reloadData() {
    this.getData({ ignoreStored: true });
  }

  // overrides mixin method
  public getStoreParams(payload: any): Promise<any> {
    return {
      ...payload,
      accountId: this.accountId
    };
  }

  public copyToClipboard(link) {
    this.$copyToClipboard(this.$affiliateMethods.generateLink(link.hash));
  }

  public async openDeleteConfirmation(link: IAffiliateLink) {
    if (!this.affiliateData.canDeleteLink) {
      return;
    }

    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: false,
          mode: ConfirmModalModes.BUTTON,
          confirmButtonText: this.$t("_action.delete"),
          message: this.$t("_sentence.delete_confirmation", {
            object: (this.$t("_.affiliate_link") as string).toLowerCase()
          })
        },
        events: {
          confirmed: async () => {
            await this.$store.dispatch(`data/${this.dataModule}/remove`, {
              id: link.id,
              accountId: this.accountId,
              vm: this
            });
            this.reloadData();
            confirm.close();
          }
        }
      }
    });
  }

  public beforeDestroy() {
    this.$bus.$off("refreshAffiliateLinksTable");
  }
}
